export enum Color {
  RED = 'Rosu',
  BLUE = 'Albastru',
  GREEN = 'Verde',
  ORANGE = 'Portocaliu',
  BROWN = 'Maro',
  PURPLE = 'Mov'
}
